import {combineReducers} from '@reduxjs/toolkit';
import {alertsSlice} from 'src/modules/profile/user/tabs/content/alerts/slices/alertsSlice';
import {layoutsCountSlice} from 'src/modules/profile/user/tabs/content/layouts/slices/layoutsCountSlice';
import {layoutsSlice} from 'src/modules/profile/user/tabs/content/layouts/slices/layoutsSlice';
import {listsSlice} from 'src/modules/profile/user/tabs/content/lists/slices/listsSlice';
import {searchesSlice} from 'src/modules/profile/user/tabs/content/searches/slices/searchesSlice';
import {workspacesSlice} from 'src/modules/profile/user/tabs/content/workspace/slices/workspacesSlice';

export const userContentReducer = combineReducers({
    workspaces: workspacesSlice.reducer,
    alerts: alertsSlice.reducer,
    searches: searchesSlice.reducer,
    lists: listsSlice.reducer,
    layouts: layoutsSlice.reducer,
    layoutsCount: layoutsCountSlice.reducer,
});
